import { render, staticRenderFns } from "./header.vue?vue&type=template&id=5edcf4df&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&lang=less&"
import style1 from "./header.vue?vue&type=style&index=1&id=5edcf4df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edcf4df",
  null
  
)

export default component.exports